import { useContext } from "react";
import {
  AppItemRestServicesType,
  AppRestServicesType,
} from "../services/appServices";
import { ServicesContext } from "@/providers/services/ServicesContext";

export const useServices = (): AppRestServicesType => {
  const services = useContext(ServicesContext);
  if (!services) throw new Error("useAuth must be used within an AuthContext");
  return services;
};

const useService = <T>(selector: (services: AppRestServicesType) => T): T => {
  const services = useServices();
  return selector(services);
};

export const useItemService = <T>(
  selector: (services: AppItemRestServicesType) => T
): T => {
  const services = useService((services) => services.items);
  return selector(services);
};
